<div class="m-subheader" appunwraptag="">
    <div class="d-flex align-items-center">
        <div class="mr-auto">
            <h3 class="m-subheader__title m-subheader__title--separator">
                Dashboard
            </h3>
            <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
                <li class="m-nav__item m-nav__item--home">
                    <a routerLink=".." class="m-nav__link m-nav__link--icon">
                        <i class="m-nav__link-icon la la-home"></i>
                    </a>
                </li>
                <li class="m-nav__separator">
                    -
                </li>
                <li class="m-nav__item">
                    <span class="m-nav__link">
                        <span>
                            Deactivation Requests
                        </span>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</div>

<div class="m-content" style="padding-right: 25px!important;">
    <div class="m-portlet m-portlet--mobile">
        <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
                <br>
                <div class="m-portlet__head-title col-12">
                    <h3 class="m-portlet__head-text">
                        Deactivation Requests
                        <span class="push-right">
                            <button type="button" class="btn btn-secondary pull-right" (click)="location.back()">
                                Back
                            </button>
                        </span>
                    </h3>
                </div>
                <br>
            </div>
        </div>
        <div class="m-portlet">
            <div class="m-portlet__body">
                <div class="row">
                    <table class="table table-bordered table-margin">
                        <thead>
                            <tr>
                                <th>
                                    <b>Request ID</b>
                                </th>
                                <th>
                                    <b>Reason</b>
                                </th>
                                <th>
                                    <b>Action Taken By</b>
                                </th>
                                <th>
                                    <b>Action Taken On</b>
                                </th>
                                <th>
                                    <b>Status</b>
                                </th>
                                <th>
                                    <b>Action</b>
                                </th>
                            </tr>
                        </thead>
                        <tbody class="notranslate">
                            <tr *ngFor="let request of deactivationRequests; let i = index">
                                <td>
                                    {{request?.requestId || 'N/A'}}
                                </td>
                                <td>
                                    {{request?.reason || 'N/A'}}
                                </td>
                                <td>
                                    {{request?.actionTakenBy || 'N/A'}}
                                </td>
                                <td>
                                    {{request?.actionTakenOn | date: 'dd/MM/yyyy'}}
                                </td>
                                <td>
                                    {{ getStatus(request) }}
                                </td>
                                <td>
                                    <span style="overflow: visible; width: 100px;">
                                        <div class="dropdown">
                                            <a href="javascript:;"
                                                class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill"
                                                data-toggle="dropdown">
                                                <i class="la la-ellipsis-h"></i>
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-left">
                                                <a *ngIf="request?.status === 'Sent Back'" class="dropdown-item"
                                                    (click)="takeAction(request)">
                                                    <span class="m-nav__link-text hover-font hover-padding">
                                                        Resubmit Request
                                                    </span>
                                                </a>
                                                <a *ngIf="request?.remarksFromPMU !== null" class="dropdown-item"
                                                    (click)="viewComment(request)">
                                                    <span class="m-nav__link-text hover-font hover-padding">
                                                        View comments
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </span>
                                </td>
                            </tr>
                            <tr *ngIf="length === 0">
                                <td colspan="9">No Data Found</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    <app-pagination #pagenation [count]="length" (pageNumber)="assignPageNo($event)"
                        (recordsPerPage)="assignRecordsPerPage($event)"></app-pagination>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="deactivate_user" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" *ngIf="deactivateUserProfile">
            <div class="modal-header">
                <h5 class="modal-title">
                    <b> Resubmit Deactivation Request </b>
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="closeDeactivationForm()">
                    <span aria-hidden="true"> &times; </span>
                </button>
            </div>
            <br />
            <div class="form-group m-form__group" [formGroup]="deactivationForm">
                <div class="container">
                    <div class="form-group m-form__group row">
                        <div class="col-md-3">
                            <label class="col-form-label">
                                Reason
                                <span style="color: red">*</span>
                            </label>
                        </div>
                        <div class="col-md-9">
                            <select class="notranslate form-control m-input" (change)="selectedReason($event)"
                                formControlName="reason">
                                <option value="" disabled selected>Select reason</option>
                                <option value="duplicate">Duplicate Profile</option>
                                <option value="notInterested">Not Interested</option>
                                <option value="notListed">Not Listed</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group m-form__group row" *ngIf="isDuplicate">
                        <div class="col-md-3">
                            <label class="col-form-label">
                                Duplicate Username
                                <span style="color: red">*</span>
                            </label>
                        </div>
                        <div class="col-md-9">
                            <input class="form-control m-input" name="duplicateUserName" maxlength="10"
                                placeholder="Enter Duplicate Username" formControlName="duplicateUserName">
                            <app-form-control-messages [control]="deactivationForm.get('duplicateUserName')"
                                [name]="'Username'">
                            </app-form-control-messages>
                        </div>
                    </div>
                    <div class="form-group m-form__group row" *ngIf="isEnabled">
                        <div class="col-md-3">
                            <label class="col-form-label">
                                Comment
                                <span style="color: red">*</span>
                            </label>
                        </div>
                        <div class="col-md-9">
                            <textarea class="form-control m-input" maxlength="1000" minlength="1" name="remarks"
                                placeholder="comments" formControlName="comment"></textarea>
                            <app-form-control-messages [control]="deactivationForm.get('comment')" [name]="'Comment'">
                            </app-form-control-messages>
                        </div>
                    </div>
                    <div class="form-group m-form__group row">
                        <div class="col-md-3">
                            <label class="col-form-label">
                                Upload Documents
                            </label>
                        </div>
                        <div class="col-md-9">
                            <app-upload-file [formValue]="deactivationForm.get('document')"
                                [(value)]="localFileName.document" fileType="document"
                                [(localFile)]="localFileName.localFile" info="only jpg, png, jpeg, pdf">
                            </app-upload-file>
                            <br>
                            <input type="hidden" formControlName="document" #fileInput>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeDeactivationForm()">
                    Cancel
                </button>
                <button type="button" class="btn btn-info color-info" (click)="submitDeactivationRequest()">
                    Submit
                </button>
            </div>
        </div>
    </div>
</div>

<!-- View Comment Modal -->
<div class="modal fade" id="view_comment" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                    Received Comments from PMU
                </h5>
                <button type="button" class="close" data-dismiss="modal" (click)="closeCommentModal()"
                    aria-label="Close">
                    <span aria-hidden="true"> &times; </span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <div class="m-section">
                            <div *ngFor="let remark of remarksFromPMU" class="m-section__content">
                                <div class="form-group m-form__group row">
                                    <div class="col-md-3">
                                        <label class="col-form-label">
                                            <strong>Remarks On:</strong>
                                        </label>
                                    </div>
                                    <div class="col-md-9">
                                        {{remark.remarksOn | date: 'dd/MM/yyyy'}}
                                    </div>
                                </div>
                                <div class="form-group m-form__group row">
                                    <div class="col-md-3">
                                        <label class="col-form-label">
                                            <strong>Remarks:</strong>
                                        </label>
                                    </div>
                                    <div class="col-md-9">
                                        {{remark.remarks}}
                                    </div>
                                </div>
                                <hr>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>